module.exports = __webpack_public_path__ + "img/italy-congenital-and-perinatal-diseases-male.49725c9e.png";